module.exports = __webpack_public_path__ + "img/topindicator.dfc1fc4a.png";